import React from 'react';
import { HTML } from '../../../HTML';
import { AspectRatioWrapper } from './partials';
export var EmbeddedContent = function EmbeddedContent(_ref) {
  var node = _ref.node;
  return React.createElement(HTML, {
    html: node.outerHTML,
    wrapper: AspectRatioWrapper,
    recursive: false
  });
};